import {
  Calculator,
  Scale,
  Lightbulb,
  Microscope,
  Briefcase,
  ArrowUpRight,
} from "lucide-react";

const SERVICES = [
  {
    icon: Calculator,
    label: "01 — Contable & Fiscal",
    title: "Servicios de Contabilidad y Auditoría Técnica",
    description:
      "Gestión contable general y procesos de fiscalización profunda para asegurar el cumplimiento tributario y la detección preventiva de riesgos financieros.",
  },
  {
    icon: Scale,
    label: "02 — Legal",
    title: "Servicios Legales y Resolución de Trámites",
    description:
      "Representación jurídica en diversas ramas del derecho y apoyo estratégico en la gestión ante autoridades para la resolución eficiente de expedientes.",
  },
  {
    icon: Lightbulb,
    label: "03 — Estratégico",
    title: "Servicios de Consultoría Técnica y Administrativa",
    description:
      "Asesoría especializada en la optimización de procesos corporativos, fundamentada en métodos científicos para mejorar la toma de decisiones empresariales.",
  },
  {
    icon: Microscope,
    label: "04 — Peritaje",
    title: "Servicios de Auditoría Científica y Profesional",
    description:
      "Servicios de validación y peritaje técnico que aportan certeza sobre la veracidad y legalidad de las operaciones comerciales de nuestros clientes.",
  },
  {
    icon: Briefcase,
    label: "05 — Especialidad",
    title: "Servicios Profesionales de Especialidad",
    description:
      "Un catálogo diverso de soluciones técnicas adaptadas a las necesidades específicas de sectores industriales, científicos y comerciales.",
  },
];

export default function Servicios() {
  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="relative py-24 lg:py-32 bg-[#0A0A0A] text-white overflow-hidden"
    >
      {/* Subtle background pattern */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, #ffffff 1px, transparent 0)",
          backgroundSize: "32px 32px",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 mb-16 items-end">
          <div className="lg:col-span-7">
            <div className="reveal eyebrow text-[#EDB900] mb-5">
              Nuestros Productos y Servicios
            </div>
            <h2 className="reveal font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Soluciones de alta especialidad,{" "}
              <span className="italic text-[#E97906]">forjadas</span> con
              precisión.
            </h2>
          </div>
          <div className="lg:col-span-5 reveal">
            <p className="text-neutral-300 text-base lg:text-[17px] leading-relaxed">
              Cada servicio nace del cruce entre disciplinas — derecho,
              contabilidad, métodos científicos y consultoría — para entregar
              certeza, blindaje y eficacia.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-7">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <article
                key={s.title}
                data-testid={`service-${i}`}
                className={`reveal group relative bg-white text-neutral-900 p-8 lg:p-10 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_30px_60px_-30px_rgba(233,121,6,0.6)]
                  ${i === 4 ? "md:col-span-2 lg:col-span-1" : ""}`}
              >
                <div className="flex items-start justify-between">
                  <span className="inline-flex items-center justify-center w-12 h-12 bg-[#FFF7F0] text-[#E97906]">
                    <Icon size={22} />
                  </span>
                  <span className="inline-flex items-center justify-center w-10 h-10 border border-neutral-200 text-neutral-400 group-hover:text-[#E97906] group-hover:border-[#E97906] transition-colors">
                    <ArrowUpRight size={18} />
                  </span>
                </div>

                <div className="mt-8 text-[11px] tracking-[0.24em] uppercase text-neutral-500">
                  {s.label}
                </div>
                <h3 className="font-serif-display text-2xl leading-snug mt-3 text-neutral-950">
                  {s.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-neutral-600">
                  {s.description}
                </p>

                <div className="mt-8 h-px w-12 bg-neutral-200 group-hover:w-full group-hover:bg-[#E97906] transition-all duration-700" />
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
